import { useQuery } from "@tanstack/react-query";
import { loadActiveAuthBackend, AUTHENTICATION_QUERY_KEY } from "hooks/useAuthentication";
const useActiveBackend = () => {
  var _a;
  const { data, isSuccess } = useQuery({
    queryKey: [...AUTHENTICATION_QUERY_KEY, "active"],
    queryFn: loadActiveAuthBackend
  });
  return {
    finishedLoading: isSuccess,
    activeBackend: data == null ? void 0 : data.backend,
    backendsTotal: (_a = data == null ? void 0 : data.context) == null ? void 0 : _a.backendsTotal
  };
};
export default useActiveBackend;
